import { kv } from '@app/booking-libs';
export function fromJiraFieldsToBookingFields(config, jiraFields) {
    const fields = {};
    const errors = [];
    const startField = jiraFields.find((f) => f.fieldId === config.startFieldId);
    if (!startField) {
        errors.push(`Start Field was not found ${kv('id', config.startFieldId)}`);
    }
    else {
        fields.startDate = {
            label: startField.name
        };
    }
    const endField = jiraFields.find((f) => f.fieldId === config.endFieldId);
    if (!endField) {
        errors.push(`End Field was not found ${kv('id', config.endFieldId)}`);
    }
    else {
        fields.endDate = {
            label: endField.name
        };
    }
    if (config.resourceSource === 'customfield') {
        const resourceField = jiraFields.find((f) => f.fieldId === config.resourceFieldId);
        if (!resourceField) {
            errors.push(`Resource Field was not found ${kv('id', config.resourceFieldId)}`);
        }
        else {
            fields.resource = {
                label: resourceField.name
            };
        }
    }
    return {
        fields,
        errors
    };
}
